import { Form } from 'factorial-form'
import { ContractsEmployeesContractVersionFragment } from 'generated/resources/graphql'
import moment from 'moment'

import { stringToDate } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import { ContractFlowType } from 'modules/contracts/components/FlowPage'

const isEmpty = (array: string[]) => array.length === 0

export const stepHasErrors = (
  form: Form,
  contractVersions: ContractsEmployeesContractVersionFragment[],
  type: ContractFlowType
) => {
  const effectiveOnErrors = getEffectiveOnErrors(form, contractVersions, type)
  const startsOnErrors = getStartsOnErrors(form)

  return !isEmpty(effectiveOnErrors) || !isEmpty(startsOnErrors)
}

const getEffectiveOnErrors = (
  form: Form,
  contractVersions: ContractsEmployeesContractVersionFragment[],
  type: ContractFlowType
): string[] => {
  const errors: string[] = []
  const effectiveOnField = form.get('effective_on')
  const effectiveOnValue = effectiveOnField.value
  if (!effectiveOnValue && effectiveOnField.isDirty)
    errors.push(i18n.t('contract_versions.flows.fix.errors.mandatory'))
  const effectiveOn = stringToDate(effectiveOnValue, 'ui')

  const sameDateVersion = contractVersions.find(
    (cv) =>
      stringToDate(cv.effectiveOn, 'backend').isSame(effectiveOn) &&
      (type !== 'fix' || cv.id !== form.get('id').value)
  )

  if (sameDateVersion)
    errors.push(i18n.t('contract_versions.flows.fix.steps.dates.errors.duplicated_effective_on'))

  form.get('effective_on').setErrors(errors)
  return errors
}

const getStartsOnErrors = (form: Form): string[] => {
  const errors: string[] = []
  if (!form.has('starts_on')) return errors
  const startsOnField = form.get('starts_on')
  const startsOnValue = startsOnField.value

  if (!form.has('effective_on')) return errors
  const effectiveOnField = form.get('effective_on')
  const effectiveOnValue = effectiveOnField.value

  // L is locale dependent -- 2 digits for day, month and 4 digits for year
  const localizedDateFormat = moment.localeData().longDateFormat('L')
  const startsOnDate = moment(startsOnValue, localizedDateFormat)
  const effectiveAtDate = moment(effectiveOnValue, localizedDateFormat)

  const startsOnAfterEffectiveOn = startsOnDate.isAfter(effectiveAtDate)

  if (startsOnAfterEffectiveOn)
    errors.push(
      i18n.t('contract_versions.flows.fix.steps.dates.errors.starts_on_after_effective_on')
    )

  form.get('starts_on').setErrors(errors)
  return errors
}
